import '../styles/index.css';

export interface TimePassDisplayProps {
  description: string;
}

export function TimePassDisplay({ description }: TimePassDisplayProps) {
  return (
    <div className="pawa-timepass-container pawa-chat-item">
      <div className="pawa-timepass-content">
        <div className="pawa-timepass-line" />
        <div className="pawa-timepass-text">{description}</div>
        <div className="pawa-timepass-line" />
      </div>
    </div>
  );
}
